import { useState } from '#imports'

/**
 * Helper to track routes which have already been visited (server + client-side)
 * This is used to deduplicate the /:locale/:app/translations/:route HTTP requests inside the loadRouteTranslations.global middleware
 */
export function useVisitedRoutes() {
  const visitedRoutes = useState<string[]>(
    'loaded-translations-routes',
    () => [],
  )

  function visitRoute(routeName: string) {
    if (visitedRoutes.value.includes(routeName)) {
      return
    }

    visitedRoutes.value.push(routeName)
  }

  function hasBeenVisited(routeName: string) {
    return visitedRoutes.value.includes(routeName)
  }

  return {
    hasBeenVisited,
    visitRoute,
  }
}
